<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
            class="box"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="code"
                    label="编号"
                    prop="code"
                    :help="formErr.code"
                    :validateStatus='!formErr.code||formErr.code==""?"":"error"'
            >
                <a-input
                        :maxLength=50
                        v-model="form.code"
                        @change="(e) => { formErr.code=''}"
                        @blur="(e) => {  form.code = e.target.value.trim();}"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="home_content"
                    label="首页内容"
                    prop="home_content"
                    :help="formErr.home_content"
                    :validateStatus='!formErr.home_content||formErr.home_content==""?"":"error"'
            >
                <a-textarea  :rows="4" v-model="form.home_content"
                              @change="(e) => { formErr.home_content=''}"
                              @blur="(e) => {  form.home_content = e.target.value.trim() }"/>
            </a-form-model-item>
            <a-form-model-item
                    ref="logo_size"
                    label="Logo尺寸"
                    prop="logo_size"
                    :help="formErr.logo_size"
                    :validateStatus='!formErr.logo_size||formErr.logo_size==""?"":"error"'
            >
                <a-input :maxLength=20
                        v-model="form.logo_size"
                        @change="(e) => { formErr.logo_size=''}"
                        @blur="(e) => {  form.logo_size = e.target.value.trim(); }"
                />
            </a-form-model-item>
<!--            <a-form-model-item-->
<!--                    ref="home_banner_size"-->
<!--                    label="首页banner图尺寸"-->
<!--                    prop="home_banner_size"-->
<!--                    :help="formErr.home_banner_size"-->
<!--                    :validateStatus='!formErr.home_banner_size||formErr.home_banner_size==""?"":"error"'-->
<!--            >-->
<!--                <a-input :maxLength=20-->
<!--                        v-model="form.home_banner_size"-->
<!--                        @change="(e) => { formErr.home_banner_size=''}"-->
<!--                        @blur="(e) => {  form.home_banner_size = e.target.value.trim()}"-->
<!--                />-->
<!--            </a-form-model-item>-->
            <a-form-model-item
                    ref="page_banner_size"
                    label="分页广告图尺寸"
                    prop="page_banner_size"
                    :help="formErr.page_banner_size"
                    :validateStatus='!formErr.page_banner_size||formErr.page_banner_size==""?"":"error"'
            >
                <a-input :maxLength=20
                        v-model="form.page_banner_size"
                        @change="(e) => { formErr.page_banner_size=''}"
                        @blur="(e) => {  form.page_banner_size = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="product_category_size"
                    label="产品分类缩略图尺寸"
                    prop="product_category_size"
                    :help="formErr.product_category_size"
                    :validateStatus='!formErr.product_category_size||formErr.product_category_size==""?"":"error"'
            >
                <a-input :maxLength=20
                        v-model="form.product_category_size"
                        @change="(e) => { formErr.product_category_size=''}"
                        @blur="(e) => {  form.product_category_size = e.target.value.trim()}"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="product_size"
                    label="产品图片尺寸"
                    prop="product_size"
                    :help="formErr.product_size"
                    :validateStatus='!formErr.product_size||formErr.product_size==""?"":"error"'
            >
                <a-input :maxLength=20
                        v-model="form.product_size"
                        @change="(e) => { formErr.product_size=''}"
                        @blur="(e) => {  form.product_size = e.target.value.trim() }"
                />
            </a-form-model-item>
          <a-form-model-item
              ref="product_image_text_size"
              label="产品图文尺寸"
              prop="product_image_text_size"
              :help="formErr.product_image_text_size"
              :validateStatus='!formErr.product_image_text_size||formErr.product_image_text_size==""?"":"error"'
          >
            <a-input :maxLength=20
                     v-model="form.product_image_text_size"
                     @change="(e) => { formErr.product_image_text_size=''}"
                     @blur="(e) => {  form.product_image_text_size = e.target.value.trim() }"
            />
          </a-form-model-item>
            <a-form-model-item
                    ref="news_size"
                    label="文章缩略图尺寸"
                    prop="news_size"
                    :help="formErr.news_size"
                    :validateStatus='!formErr.news_size||formErr.news_size==""?"":"error"'
            >
                <a-input :maxLength=20
                        v-model="form.news_size"
                        @change="(e) => { formErr.news_size=''}"
                        @blur="(e) => {  form.news_size = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="case_size"
                    label="案例图片尺寸"
                    prop="case_size"
                    :help="formErr.case_size"
                    :validateStatus='!formErr.case_size||formErr.case_size==""?"":"error"'
            >
                <a-input :maxLength=20
                        v-model="form.case_size"
                        @change="(e) => { formErr.case_size=''}"
                        @blur="(e) => {  form.case_size = e.target.value.trim()}"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="certificate_size"
                    label="证书图片尺寸"
                    prop="certificate_size"
                    :help="formErr.certificate_size"
                    :validateStatus='!formErr.certificate_size||formErr.certificate_size==""?"":"error"'
            >
                <a-input :maxLength=20
                        v-model="form.certificate_size"
                        @change="(e) => { formErr.certificate_size=''}"
                        @blur="(e) => {  form.certificate_size = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="video_size"
                    label="视频缩略图尺寸"
                    prop="video_size"
                    :help="formErr.video_size"
                    :validateStatus='!formErr.video_size||formErr.video_size==""?"":"error"'
            >
                <a-input :maxLength=20
                        v-model="form.video_size"
                        @change="(e) => { formErr.video_size=''}"
                        @blur="(e) => {  form.video_size = e.target.value.trim()}"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="product_page_size"
                    label="产品列表每页数量"
                    prop="product_page_size"
                    :help="formErr.product_page_size"
                    :validateStatus='!formErr.product_page_size||formErr.product_page_size==""?"":"error"'
            >
                <a-input-number :max="99"
                        v-model="form.product_page_size"
                        @change="(e) => { formErr.product_page_size=''}" :precision="0"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="news_page_size"
                    label="新闻列表每页数量"
                    prop="news_page_size"
                    :help="formErr.news_page_size"
                    :validateStatus='!formErr.news_page_size||formErr.news_page_size==""?"":"error"'
            >
                <a-input-number :max="99"
                        v-model="form.news_page_size"
                        @change="(e) => { formErr.news_page_size=''}" :precision="0"
                />
            </a-form-model-item>
            <a-form-model-item
                ref="case_page_size"
                label="案例列表每页数量"
                prop="case_page_size"
                :help="formErr.case_page_size"
                :validateStatus='!formErr.case_page_size||formErr.case_page_size==""?"":"error"'
        >
            <a-input-number
                    :max="99"
                    v-model="form.case_page_size"
                    @change="(e) => { formErr.case_page_size=''}" :precision="0"
            />
        </a-form-model-item>
            <a-form-model-item
                    ref="video_page_size"
                    label="视频列表每页数量"
                    prop="video_page_size"
                    :help="formErr.video_page_size"
                    :validateStatus='!formErr.video_page_size||formErr.video_page_size==""?"":"error"'
            >
                <a-input-number :max="99"
                        v-model="form.video_page_size"
                        @change="(e) => { formErr.video_page_size=''}" :precision="0"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="certificate_page_size"
                    label="证书列表每页数量"
                    prop="certificate_page_size"
                    :help="formErr.certificate_page_size"
                    :validateStatus='!formErr.certificate_page_size||formErr.certificate_page_size==""?"":"error"'
            >
                <a-input-number :max="99"
                        v-model="form.certificate_page_size"
                        @change="(e) => { formErr.certificate_page_size=''}" :precision="0"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="faq_page_size"
                    label="FAQ列表每页数量"
                    prop="faq_page_size"
                    :help="formErr.faq_page_size"
                    :validateStatus='!formErr.faq_page_size||formErr.faq_page_size==""?"":"error"'
            >
                <a-input-number :max="99"
                        v-model="form.faq_page_size"
                        @change="(e) => { formErr.faq_page_size=''}" :precision="0"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="download_page_size"
                    label="下载列表每页数量"
                    prop="download_page_size"
                    :help="formErr.download_page_size"
                    :validateStatus='!formErr.download_page_size||formErr.download_page_size==""?"":"error"'
            >
                <a-input-number :max="99"
                        v-model="form.download_page_size"
                        @change="(e) => { formErr.download_page_size=''}" :precision="0"
                />
            </a-form-model-item>

            <a-form-model-item
                    ref="a_template_color_id"
                    label="颜色"
                    prop="a_template_color_id"
                    :help="formErr.a_template_color_id"
                    :validateStatus='!formErr.a_template_color_id||formErr.a_template_color_id==""?"":"error"'
            >

                    <a-checkbox-group v-model="form.a_template_color_id" >
                        <a-checkbox :value="item.id" v-for="item in this.seleList.colorList">
                            {{item.name}}
                        </a-checkbox>
                    </a-checkbox-group>
            </a-form-model-item>
            <a-form-model-item
                    ref="a_template_style_id"
                    label="风格"
                    prop="a_template_style_id"
                    :help="formErr.a_template_style_id"
                    :validateStatus='!formErr.a_template_style_id||formErr.a_template_style_id==""?"":"error"'
            >
                <a-checkbox-group v-model="form.a_template_style_id" >
                            <a-checkbox :value="item.id" v-for="item in this.seleList.styleList">
                               {{item.name}}
                            </a-checkbox>
                </a-checkbox-group>
            </a-form-model-item>

            <a-form-model-item
                    ref="thumb"
                    label="可视化图片"
                    prop="thumb"
                    :extra="formErr.thumb"
                    :validateStatus='!formErr.thumb||formErr.thumb==""?"":"error"'
            >
                <a-upload
                        :action="this.$store.state.urlChang"
                        :data="{type:3}"
                        :file-list="fileList"
                        :headers="headers"
                        @change="(file)=>{handleChange(file,1)}"
                        :before-upload="beforeUpload"
                        @preview="handlePreview"
                        list-type="picture-card"
                        name="file"
                >
                    <div v-if="fileList.length < 1">
                        <a-icon type="plus"/>
                        <div class="ant-upload-text">Upload</div>
                    </div>
                </a-upload>
                <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                    <img :src="previewImage" alt="example" style="width: 100%"/>
                </a-modal>
            </a-form-model-item>

            <a-form-model-item
                    ref="thumb_small"
                    label="模板图"
                    prop="thumb_small"
                    :extra="formErr.thumb_small"
                    :validateStatus='!formErr.thumb_small||formErr.thumb_small==""?"":"error"'
            >
                <a-upload
                        :action="this.$store.state.urlChang"
                        :data="{type:3}"
                        :file-list="fileListSmall"
                        :headers="headers"
                        @change="(file)=>{handleChange(file,2)}"
                        :before-upload="beforeUpload"
                        @preview="handlePreview"
                        list-type="picture-card"
                        name="file"
                >
                    <div v-if="fileListSmall.length < 1">
                        <a-icon type="plus"/>
                        <div class="ant-upload-text">Upload</div>
                    </div>
                </a-upload>
                <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                    <img :src="previewImage" alt="example" style="width: 100%"/>
                </a-modal>
            </a-form-model-item>
          <a-form-model-item
              ref="product_page_data"
              label="产品导航调取"
              prop="product_page_data"
              :help="formErr.product_page_data"
              :validateStatus="!formErr.product_page_data || formErr.product_page_data == '' ? '' : 'error'"
          >
            <a-radio-group v-model="form.product_page_data" >
              <a-radio :value="1"> 产品列表</a-radio>
              <a-radio :value="2"> 产品分类</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
              ref="is_banner_video"
              label="是否有视频"
              prop="is_banner_video"
              :extra="formErr.is_banner_video"
              :validateStatus='!formErr.is_banner_video||formErr.is_banner_video==""?"":"error"'
          >
            <a-radio-group v-model="form.is_banner_video"  >
              <a-radio :value="item.value" v-for="item in this.seleList.is_banner_video"> {{item.name}} </a-radio>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item
              ref="is_order_message"
              label="订单报文"
              prop="is_order_message"
              :extra="formErr.is_order_message"
              :validateStatus='!formErr.is_order_message||formErr.is_order_message==""?"":"error"'
          >
            <a-radio-group v-model="form.is_order_message"  >
              <a-radio :value="item.value" v-for="item in this.seleList.is_order_message"> {{item.name}} </a-radio>

            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
              ref="is_popup"
              label="网站弹框"
              prop="is_popup"
              :extra="formErr.is_popup"
              :validateStatus='!formErr.is_popup||formErr.is_popup==""?"":"error"'
          >
            <a-radio-group v-model="form.is_popup"  >
              <a-radio :value="1" > 是 </a-radio>
              <a-radio :value="2" > 否 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
              ref="is_proxy"
              label="代理模板"
              prop="is_proxy"
              :extra="formErr.is_proxy"
              :validateStatus='!formErr.is_proxy||formErr.is_proxy==""?"":"error"'
          >
            <a-radio-group v-model="form.is_proxy"  >
              <a-radio :value="1" > 是 </a-radio>
              <a-radio :value="2" > 否 </a-radio>
            </a-radio-group>
          </a-form-model-item>
            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="item.value" v-for="item in this.seleList.status"> {{item.name}} </a-radio>

                </a-radio-group>
            </a-form-model-item>

        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator,beforeUpload} from "../../../../utils/utils"
    import API from "../api";
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    function isJSON(str) {
        if (typeof str == 'string') {
            try {
                var obj=JSON.parse(str);
                if(typeof obj == 'object' && obj ){
                    return true;
                }else{
                    return false;
                }
            } catch(e) {
                return false;
            }
        }
    }
    export default {
        name: "templateForm",
        props: ["visible","title","editId"],
        data() {
            let validator2=(rule, value, callback,errval)=> {
                let formerrname=rule.field
                if( errval!=""){
                    callback(new Error(errval))
                }else if(errval==""){
                    callback()
                } else if(!isJSON(this.form.home_content)  ){
                    callback(new Error("请填写json格式数据"))
                } else{   callback();}
            }
            let validator3=(rule, value, callback,errval)=> {
                let formerrname=rule.field
                var test = /^[0-9]+x[0-9]+$/;
                if( errval!=""){
                    callback(new Error(errval))
                } else if(value!=""&&!test.test(value) ){
                    callback(new Error("请填写100x100格式数据"))
                } else{   callback();}
            }
            return {
                drawerConfig ,
                seleList:[],
                fileList:[],
                fileListSmall:[],
                previewVisible: false,
                previewImage: "",
                headers: {Authorization: window.sessionStorage.getItem("signature")},
                form: {
                    code:"",
                    home_content:"",
                    logo_size:"",
                    home_banner_size:"",
                    page_banner_size:"",
                    product_category_size:"",
                    product_size:"",
                  product_image_text_size:'',
                    news_size:"",
                    case_size:"",
                    certificate_size:"",
                    video_size:"",
                    product_page_size:"",
                    news_page_size:"",
                    case_page_size:"",
                    video_page_size	:"",
                    certificate_page_size:"",
                    faq_page_size:"",
                    download_page_size:"",
                    thumb:"",
                    status:1,
                    a_template_style_id:[],
                    a_template_color_id:[],
                    is_banner_video:2,
                    thumb_small:"",
                  is_order_message:2,
                  is_proxy:2,
                  is_popup:2,product_page_data:1
                },
                formErr: {
                  is_popup:'',
                    code:"",
                    home_content:"",
                    logo_size:"",
                    // home_banner_size:"",
                    page_banner_size:"",
                    product_category_size:"",
                    product_size:"",
                  product_image_text_size:'',
                    news_size:"",
                    case_size:"",
                    certificate_size:"",
                    video_size:"",
                    product_page_size:"",
                    news_page_size:"",
                    case_page_size:"",
                    video_page_size	:"",
                    certificate_page_size:"",
                    faq_page_size:"",
                    download_page_size:"",
                    thumb:"",
                    status:"",
                    a_template_style_id:"",
                    a_template_color_id:"",
                    is_banner_video:"",
                    thumb_small:"",
                  is_order_message:"",
                  is_proxy:'',product_page_data:''
                },
            // {required: true, message: "请输入首页内容", trigger: "blur"},{ whitespace: true, message: "请输入首页内容 " },
            rules: {
                    code: [{required: true, message: "请输入编号", trigger: "blur"}, { whitespace: true, message: "请输入编号 " },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.code)}  , trigger: "blur"  },],
                    home_content: [{validator:(rule, value, callback)=>{validator2(rule, value, callback,this.formErr.home_content)}  , trigger: "blur"  },],
                    logo_size: [{validator:(rule, value, callback)=>{validator3(rule, value, callback,this.formErr.home_content)}  , trigger: "blur"  },],
                    // home_banner_size:[{validator:(rule, value, callback)=>{validator3(rule, value, callback,this.formErr.home_banner_size)}  , trigger: "blur"  },],
                    page_banner_size:[{validator:(rule, value, callback)=>{validator3(rule, value, callback,this.formErr.page_banner_size)}  , trigger: "blur"  },],
                    product_category_size:[{validator:(rule, value, callback)=>{validator3(rule, value, callback,this.formErr.product_category_size)}  , trigger: "blur"  },],
                    product_size:[{validator:(rule, value, callback)=>{validator3(rule, value, callback,this.formErr.product_size)}  , trigger: "blur"  },],
              product_image_text_size:[{validator:(rule, value, callback)=>{validator3(rule, value, callback,this.formErr.product_image_text_size)}  , trigger: "blur"  },],
                    news_size:[{validator:(rule, value, callback)=>{validator3(rule, value, callback,this.formErr.news_size)}  , trigger: "blur"  },],
                    case_size:[{validator:(rule, value, callback)=>{validator3(rule, value, callback,this.formErr.case_size)}  , trigger: "blur"  },],
                    certificate_size:[{validator:(rule, value, callback)=>{validator3(rule, value, callback,this.formErr.certificate_size)}  , trigger: "blur"  },],
                    video_size:[{validator:(rule, value, callback)=>{validator3(rule, value, callback,this.formErr.video_size)}  , trigger: "blur"  },],
                    product_page_size:[{required: true, message: "请输入产品列表每页数量", },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.product_page_size)}  , trigger: "blur"  },],
                    news_page_size:[{required: true, message: "请输入新闻列表每页数量", },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.news_page_size)}  , trigger: "blur"  },],
                    case_page_size:[{required: true, message: "请输入案例列表每页数量", },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.case_page_size)}  , trigger: "blur"  },],
                    video_page_size	:[{required: true, message: "请输入视频列表每页数量", },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.video_page_size)}  , trigger: "blur"  },],
                    certificate_page_size:[{required: true, message: "请输入证书列表每页数量", },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.certificate_page_size)}  , trigger: "blur"  },],
                    faq_page_size:[{required: true, message: "请输入FAQ列表每页数量", },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.faq_page_size)}  , trigger: "blur"  },],
                    download_page_size:[{required: true, message: "请输入下载列表每页数量", },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.download_page_size)}  , trigger: "blur"  },],
                    a_template_style_id:[{required: true, message: "请选择风格",},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.a_template_style_id)}  , trigger: "blur"  },],
                    a_template_color_id:[{required: true, message: "请选择颜色", },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.a_template_color_id)}  , trigger: "blur"  },],
                    thumb:[{required: true, message: " ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.thumb)}  , trigger: "blur"  },],
                    thumb_small:[{required: true, message: " ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.thumb_small)}  , trigger: "blur"  },],

            },
                layout: {
                    labelCol: { span:6},
                    wrapperCol: { span: 14 },
                },
            };



        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA(a).then(res => {
                        this.form = res.data.data.info
                        if (this.form.thumb == "") {
                            this.fileList = []
                        } else {
                            this.fileList = [
                                {uid: this.form.thumb,
                                 name: this.form.thumb,
                                 status: "done",
                                 url: this.form.thumb ? this.form.thumb : ""
                                }
                            ]
                        }

                        if (this.form.thumb_small == "") {
                            this.fileListSmall = []
                        } else {
                            this.fileListSmall = [
                                {uid: this.form.thumb_small,
                                    name: this.form.thumb_small,
                                    status: "done",
                                    url: this.form.thumb_small ? this.form.thumb_small : ""
                                }
                            ]
                        }
                        this.form.id=a
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        mounted(){
            this.getFormData()
        },
        methods: {

            getFormData(){
                API.service.ADD_DATA().then(res => {
                    this.seleList=res.data.data
                })
            },
            handleCancel() {
                this.previewVisible = false;
            },
            handleChange(info ,type) {
                // alert(type)
                let {fileList} = info;
                const status = info.file.status;
                if (status !== 'uploading') {
                    type==1?this.fileList=[]:this.fileListSmall=[]
                }
                if (status === 'done') {
                    type==1?this.fileList=fileList:this.fileListSmall=fileList
                    // this.fileList= fileList
                } else if (status === 'error') {
                }
                if (status === 'uploading') {
                    type==1?this.fileList=fileList:this.fileListSmall=fileList
                    // this.fileList= fileList
                }
                if (status=== 'done') {
                    getBase64(info.file.originFileObj, imageUrl => {
                        // this.formErr.thumb=""
                        // this.fileList= fileList
                    });
                    if(type==1){
                        this.formErr.thumb=""
                    }else {
                        this.formErr.thumb_small=""
                    }
                    type==1?this.fileList=fileList:this.fileListSmall=fileList
                }
                //重新设置state
                // this.setState( {fileList});
            },
            beforeUpload(file) {
                return beforeUpload(file,5)
            },
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },
            onClose() {
                this.$emit("changVisible", false);
                this.fileList=[]
                this.fileListSmall=[],
                this.formErr={
                    code:"",
                    home_content:"",
                    logo_size:"",
                    // home_banner_size:"",
                    page_banner_size:"",
                    product_category_size:"",
                    product_size:"",
                  product_image_text_size:'',
                    news_size:"",
                    case_size:"",
                    certificate_size:"",
                    video_size:"",
                    product_page_size:"",
                    news_page_size:"",
                    case_page_size:"",
                    video_page_size	:"",
                    certificate_page_size:"",
                    faq_page_size:"",
                    download_page_size:"",
                    thumb:"",
                    status:"",
                    a_template_style_id:"",
                    a_template_color_id:"",
                    thumb_small:'',is_order_message:"",product_page_data:''
                }

                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                if (this.fileList.length < 1) {
                    _this.formErr.thumb = "请选择可视化图片";

                } else {
                    _this.formErr.thumb = "";
                    this.form.thumb = this.fileList[0].url
                }

                if (this.fileListSmall.length < 1) {
                    _this.formErr.thumb_small = "请选择模板图";
                    return

                } else {
                    _this.formErr.thumb_small = "";
                    _this.form.thumb_small = this.fileListSmall[0].url
                }


                if (this.fileList.length > 0 && this.fileList[0].url) {
                    this.form.thumb = this.fileList[0].url
                } else if (this.fileList.length > 0 && this.fileList[0].response) {
                    this.form.thumb = this.fileList[0].response.data.url
                } else {
                    this.form.thumb = ""
                }

                if (this.fileListSmall.length > 0 && this.fileListSmall[0].url) {
                    this.form.thumb_small = this.fileListSmall[0].url
                } else if (this.fileListSmall.length > 0 && this.fileListSmall[0].response) {
                    this.form.thumb_small = this.fileListSmall[0].response.data.url
                } else {
                    this.form.thumb_small = ""
                    return
                }
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
.box >>> .ant-form-extra{top:calc(100% - 10px) !important;position: absolute}
.box >>> .ant-form-item-control-wrapper{position: relative}
.box >>> .ant-checkbox-wrapper + .ant-checkbox-wrapper{margin-left: 0}
/*.box >>> .ant-form-extra*/
</style>
